<template>

  <div v-if="params.data.blocked">
    Blocked
    <img src="@/assets/images/pages/settings/users/blocked.svg" class="absolute avatar-status"/>
  </div>

  <div v-else-if="!params.data.blocked && params.data.status === 1">

    <div class="text">
      <span>Active</span>
    </div>

    <div class="image">
      <img src="@/assets/images/pages/settings/users/active.svg" class="absolute avatar-status"/>
    </div>

  </div>

  <div v-else>
    Pending
    <img src="@/assets/images/pages/settings/users/inactive.svg" class="absolute avatar-status"/>
  </div>

</template>
<script>
export default {}
</script>
